import React from 'react';
import './styles/driftOgVedligeholdelse.css';
import driftOgVedligeholdelseHero from '../images/image1.jpg';
import { FaTools, FaClipboardCheck, FaClock, FaFileAlt } from 'react-icons/fa';
import CTAButton from '../components/CTAButton';
import ContactForm from '../components/contactForm';

function DriftOgVedligeholdelse() {
  return (
    <>
      <div className="drift-hero">
        <img src={driftOgVedligeholdelseHero} alt="Drift og Vedligeholdelse" className="drift-hero-image" />
      </div>

      <section className="drift-intro">
        <div className="drift-container">
          <div className="drift-intro-content">
            <span className="drift-overline">Drift & Vedligeholdelse</span>
            <h2>En vigtig del af det færdige byggeri</h2>
            <p className="drift-intro-text">
              Drift & Vedligehold (D&V) er ikke bare en afsluttende formalitet – det er en central del af byggeriets samlede kvalitet og levetid. Når entreprenøren afleverer et byggeri, skal bygherren og de fremtidige brugere kunne overtage det med fuld indsigt i, hvordan det skal driftes, vedligeholdes og serviceres. Det kræver en gennemtænkt og brugbar D&V-dokumentation.
            </p>
          </div>
        </div>
      </section>

      <section className="drift-why-important">
        <div className="drift-container">
          <h2>Hvorfor er D&V vigtigt for entreprenøren?</h2>
          <p className="drift-intro-text">
            For entreprenøren er D&V-dokumentationen en mulighed for at afslutte projektet professionelt og ansvarligt. En veldokumenteret og overskuelig D&V-leverance:
          </p>
          <ul className="drift-benefits">
            <li>Reducerer risikoen for reklamationer, fordi brugeren ved, hvordan bygningen skal anvendes og vedligeholdes korrekt.</li>
            <li>Styrker relationen til bygherren, som oplever en tryg og velforberedt overdragelse.</li>
            <li>Minimerer efterfølgende spørgsmål og supportbehov, da svarene allerede er tilgængelige i materialet.</li>
            <li>Dokumenterer leverancen, hvilket kan være afgørende i tilfælde af tvister eller garantisager.</li>
          </ul>
          <p className="drift-intro-text">
            Mangelfuld eller ustruktureret D&V-dokumentation kan derimod føre til frustration, driftsproblemer og i værste fald økonomiske konsekvenser for entreprenøren.
          </p>
        </div>
      </section>

      <section className="drift-collaboration">
        <div className="drift-container">
          <h2>Gør det nemt – samarbejd med mig</h2>
          <p className="drift-intro-text">
            Jeg tilbyder hjælp til at udarbejde professionel D&V-dokumentation, der lever op til kravene i udbudsmaterialet og samtidig er let at forstå og anvende for driftspersonalet. Du kan vælge at:
          </p>
          <div className="drift-options">
            <div className="drift-option">
              <h3>Dokumentpakke</h3>
              <p>Købe en komplet D&V-skabelonpakke, som du selv kan tilpasse til dit projekt.</p>
            </div>
            <div className="drift-option">
              <h3>Samarbejde</h3>
              <p>Indgå et samarbejde, hvor jeg hjælper dig med at samle, strukturere og kvalitetssikre hele D&V-materialet – så du kan fokusere på byggeriet.</p>
            </div>
          </div>
          <p className="drift-intro-text">
            <strong>Med den rigtige tilgang til D&V sikrer du ikke bare en god aflevering – du styrker også din virksomheds omdømme og bundlinje.</strong>
          </p>
          <CTAButton text="Kontakt os" to="/kontakt" />
        </div>
      </section>

      <section className="drift-section">
        <div className="section-content">
          <div className="contact-section">
            <div className="contact-content">
              <div className="contact-header">
                <span className="overline">Kontakt os</span>
                <h3>Lad os tale om jeres behov</h3>
                <p className="contact-intro">
                  Vi hjælper jer med at optimere jeres byggeprojekter gennem professionel kvalitetssikring og drift & vedligehold.
                </p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default DriftOgVedligeholdelse;
